// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"error_errorWrapper__1AM2g","errorContainer":"error_errorContainer__3RDyY"};